const date = new Date(0);
export const userTimezoneOffset = date.getTimezoneOffset() * 60000;
